import React from 'react';

import CSS from './styles.scss';
import FilterBar from './FilterBar';
import AnnotationList from './AnnotationList';
import FilterPanel from 'components/FilterPanel';


const NotebookViews = ({ isMobile, styles, highlights, toggle }) => {
  return (
    <div className={ CSS['container'] } style={ styles }>
      {highlights.length === 0
        ? null
        : <FilterBar />
      }
      <AnnotationList toggle={toggle} />

      {/*check rendering here: include isFilterPanelOpen or not?*/}
      {isMobile
        ? <FilterPanel />
        : null
      }

    </div>
  );
};

NotebookViews.propTypes = {};


export default NotebookViews;
